<style>
</style>
<template>
<div></div>
</template>
<script>
import InstitutionMixin from '../mixins/institution-mixin.js'
export default {
  name: 'the-institurion',
  mixins: [InstitutionMixin],
  created() {
    this.getInstitution().catch(console.log)
  },
  methods: {
    getInstitution(value = null) {
      return this.$oauth2.$fetch('institutions' + (value ? '/' + value : '')).then(data => {
        this.institution = data[0]
        this.$vuetify.theme.dark = (this.instTheme != 'light')
        this.$vuetify.theme.themes[this.instTheme].primary = this.instPrimary
        this.$vuetify.theme.themes[this.instTheme].secondary = this.instSecondary
        return this.institution
      }).catch(console.log)
    }
  }
}
</script>
